module.exports = __webpack_public_path__ + "img/icon18.128eb7f6.png";